import React, { useEffect, useState } from "react";
import {
  Collapse,
  Container,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
} from "reactstrap";
import "./NavMenu.css";

const NavMenuLife = () => {
  const [navStyle, setNavStyle] = useState("");
  const [collapsed, setCollapsed] = useState(true);
  const [navOptions, setnavOptions] = useState("");
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const updateCollapsed = () => setCollapsed(!collapsed);

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
    if (width >= 850) {
      setNavStyle("headerNav");
      setnavOptions("navOptions");
    } else {
      setNavStyle("");
      setnavOptions("");
    }
  };
  window.addEventListener("resize", updateWindowDimensions);

  useEffect(() => {
    async function fetchData() {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
      if (width >= 850) {
        setNavStyle("headerNav");
        setnavOptions("navOptions");
      } else {
        setNavStyle("");
        setnavOptions("");
      }
    }
    fetchData();
  }, []);

  return (
    <div>
      <header className={""}>
        <Navbar
          id="navLife"
          className="navbar-expand-lg navbar-toggleable-lg ng-white"
          light
        >
          <NavLink
            href="https://www.life.com.ec/"
            className="text-dark"
            style={{ textDecoration: "none" }}
          >
            <Container className="NAV">
              <div>
                <img
                  className="logoLife"
                  alt="LogoLife"
                  src="/logoRojoLIFE.png"
                />
                {width < 444 ? (
                  <div style={{ fontSize: "18px" }}>
                    &nbsp; Laboratorios <b>LIFE </b>
                  </div>
                ) : width >= 444 && width < 980 ? (
                  <div style={{ fontSize: "18px" }}>
                    &nbsp; Laboratorios <b>LIFE </b>
                  </div>
                ) : (
                  <div style={{ fontSize: "27px" }}>
                    &nbsp; Laboratorios <b>LIFE </b>
                  </div>
                )}
                <br />
              </div>
            </Container>
          </NavLink>
          <br />
          <br />
          <br />
          <NavbarToggler onClick={updateCollapsed} className="mr-2" />
          <Collapse className="navCustom" isOpen={!collapsed} navbar>
            <ul className="navbar-nav flex-grow">
              <NavItem className="textoNav">
                <NavLink href="https://www.life.com.ec/">Inicio</NavLink>
              </NavItem>
              <NavItem className="textoNav">
                <NavLink href="https://www.life.com.ec/conocenos/">
                  Con&oacute;cenos
                </NavLink>
              </NavItem>
              <NavItem className="textoNav">
                <a
                  className="nav-link  dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Productos
                </a>
                <ul
                  className="dropdown-menu"
                  style={{ backgroundColor: "white", paddingBlock: "0px" }}
                >
                  <NavLink
                    href="https://www.life.com.ec/salud-humana/"
                    className="textoNavOpts"
                  >
                    Salud Humana
                  </NavLink>
                  <NavLink
                    href="https://www.life.com.ec/salud-animal/"
                    className="textoNavOpts"
                  >
                    Salud Amimal
                  </NavLink>
                </ul>
              </NavItem>
              <NavItem className="textoNav">
                <a
                  className="nav-link  dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Interact&uacute;a con nostros
                </a>
                <ul
                  className="dropdown-menu"
                  style={{ backgroundColor: "white", paddingBlock: "0px" }}
                >
                  <NavLink
                    href="https://bibliotecavirtual.life.com.ec/"
                    className="textoNavOpts"
                  >
                    Biblioteca
                  </NavLink>
                  <NavLink
                    href="https://futbolclub.life.com.ec/"
                    className="textoNavOpts"
                  >
                    LIFE FC
                  </NavLink>
                  <NavLink
                    href="https://www.life.com.ec/saludybienestar/"
                    className="textoNavOpts"
                  >
                    Para Ti
                  </NavLink>
                </ul>
              </NavItem>
              <NavItem className="textoNav">
                <NavLink href="https://vss.life.com.ec/">Proveedores</NavLink>
              </NavItem>
              <NavItem className="textoNav">
                <NavLink href="https://www.life.com.ec/trabaja-con-nosotros/">
                  Empleo
                </NavLink>
              </NavItem>
              <NavItem className="textoNav">
                <NavLink href="https://www.life.com.ec/contactanos/">
                  Cont&aacute;ctanos
                </NavLink>
              </NavItem>
            </ul>
          </Collapse>
        </Navbar>
        <br />
      </header>
    </div>
  );
};

export default NavMenuLife;
